export function cleanObjectStrings(obj: any): any {
  if (Array.isArray(obj)) {
    return obj.map(cleanObjectStrings);
  } else if (obj && typeof obj === 'object') {
    const cleaned: any = {};
    for (const key in obj) {
      if (!obj.hasOwnProperty(key)) continue;
      const value = obj[key];
      if (typeof value === 'string') {
        // Remove \r, \n, and trim whitespace
        cleaned[key] = value.replace(/[\r\n]+/g, '').trim();
      } else if (typeof value === 'object' && value !== null) {
        cleaned[key] = cleanObjectStrings(value);
      } else {
        cleaned[key] = value;
      }
    }
    return cleaned;
  }
  return obj;
}